module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_05_6DE79_1SF_GJI.91e20420.png";